import { z } from 'zod';

export const Z_Account = z.object({
  companies_trial_end_date: z.string().nullable(),
  companies_trial_start_date: z.string().nullable(),
  company_account_end_date: z.string().nullable(),
  company_address: z.string().nullable(),
  company_initial_engagement: z.boolean().nullable(),
  currency: z.string().nullable(),
  first_known_upgrade_date: z.string().nullable(),
  has_been_in_companies_trial: z.boolean().nullable(),
  has_modern_pricing_plan: z.boolean().nullable(),
  id: z.number(),
  is_chat_eligible: z.boolean().nullable(),
  is_company_account: z.boolean().nullable(),
  is_in_experts_mvp: z.boolean().nullable(),
  is_premier_chat_eligible: z.boolean().nullable(),
  is_team_account: z.boolean().nullable(),
  is_trialing_companies: z.boolean().nullable(),
  is_trialing_teams: z.boolean().nullable(),
  is_trialing: z.boolean().nullable(),
  is_unlimited: z.boolean().nullable(),
  last_plan_change_at: z.string().nullable(),
  logo_url: z
    .string()
    .url()
    .or(z.enum(['']))
    .optional()
    .nullable(),
  name: z.string(),
  offer_returning_trial_extension: z.boolean().nullable(),
  owner: z.object({
    id: z.number(),
    name: z.string(),
    email: z.string().email(),
  }),
  paying: z.boolean().nullable(),
  pays_manually: z.boolean().nullable(),
  period_end: z.string().nullable(),
  period_start: z.string().nullable(),
  plan_group_id: z.number().nullable(),
  plan_info: z.object({
    id: z.number(),
    name: z.string(),
    metered_task_pricing: z.boolean(),
    interval: z.string(),
    allow_companies: z.boolean().nullable(),
    allow_teams: z.boolean().nullable(),
    allow_import_export: z.boolean().nullable(),
  }),
  surveys_submitted: z.object({
    company_trial_onboarding: z.boolean().nullable(),
    company_trial_exit: z.boolean().nullable(),
  }),
  team_account_end_date: z.string().nullable(),
  teams_trial_end_date: z.string().nullable(),
  trial_auto_upgrade: z.boolean().nullable(),
  trial_end_date: z.string().nullable(),
  teams_trial_auto_upgrade: z.boolean().nullable(),
  companies_trial_auto_upgrade: z.boolean().nullable(),
  created_at: z.string(),
});

export const Z_AccountsResponse = z.object({
  count: z.number(),
  next: z.string().nullable(),
  previous: z.string().nullable(),
  results: z.array(Z_Account),
});

export type Account = z.infer<typeof Z_Account>;
export type AccountsResponse = z.infer<typeof Z_AccountsResponse>;
